<template>
  <div class="creation-demand-step-planning-dates">
    <DatesMultiple :dates="{ start, end }" :hide-icon="$q.screen.lt.md" @select-dates="openModal" />
    <DatepickerModal v-model:opened="modalOpened" :dates="{ start, end }" :min-date="minDate" :mode="calendarMode" @set-date="setDate" />
  </div>
</template>

<script>
  import { ICreationStepDates, ICreationStepPlanning, ICreationStepPlanningDay } from "@core/models";
  import { API_DATE_FORMAT_SHORT, CREATION_DATES_TYPES } from "@core/constants";
  import DatesMultiple from "@etab/components/creation/DatesMultiple.component.vue";
  import DatepickerModal from "@etab/components/creation/Datepicker.modal.vue";
  import { DatesHelpers } from "@core/helpers";

  export default {
    components: {
      DatesMultiple,
      DatepickerModal,
    },
    props: {
      planningDays: {
        type: Array,
        required: true,
      },
      stepData: {
        type: Object,
        required: true,
      },
    },
    emits: ["saveStep"],
    data() {
      return {
        modalOpened: false,
        calendarMode: "range",
        start: undefined,
        end: undefined,
        minDate: new Date(), // cannot select before today
      };
    },
    watch: {
      // if there is any change in the parent component's planning object (meaning a day has been added)
      // then update start date and end date consequently
      planningDays: {
        handler(val) {
          this.setupDates(val);
        },
        deep: true,
      },
    },
    created() {
      this.setupDates(this.stepData[ICreationStepPlanning.days]);
      this.CREATION_DATES_TYPES = CREATION_DATES_TYPES;
    },
    mounted() {
      // we hide the loading showed from routing
      this.$_stopGlobalLoading();
    },
    methods: {
      setupDates(data) {
        if (data?.length) {
          const lastDayIndex = data.length - 1;
          this.start = new Date(data[0][ICreationStepPlanningDay.date]);
          this.end = new Date(data[lastDayIndex][ICreationStepPlanningDay.date]);
        }
      },
      openModal() {
        this.modalOpened = true;
      },
      closeModal() {
        this.modalOpened = false;
      },
      setDate(value) {
        const { start, end } = value;
        this.start = start;
        this.end = end;
        this.closeModal();
        this.save();
      },
      save() {
        this.$emit("saveStep", {
          dates: {
            [ICreationStepDates.startDate]: DatesHelpers.getDayjs(this.start).format(API_DATE_FORMAT_SHORT),
            [ICreationStepDates.endDate]: DatesHelpers.getDayjs(this.end).format(API_DATE_FORMAT_SHORT),
          },
        });
      },
    },
  };
</script>

<style lang="scss">
  .creation-demand-step-planning-dates {
    width: 305px;
    @media screen and (max-width: $breakpoint-sm-max) {
      width: 270px;
    }
  }
</style>
